import { Card, CardBody, CardTitle, CardText } from 'reactstrap';

/**
 * Phase-1 Platzhalter — wird pro View durch eine echte Implementierung mit
 * Mock-Fixture in Folge-Tasks ersetzt.
 */
export function PlaceholderPage({ title, hint }) {
  return (
    <div className="app-page-title app-page-title-simple">
      <Card>
        <CardBody>
          <CardTitle tag="h4">{title}</CardTitle>
          <CardText className="text-muted">
            {hint ?? 'View kommt in Phase 2.'}
          </CardText>
        </CardBody>
      </Card>
    </div>
  );
}
